export default __webpack_public_path__ + "static/media/ruby.64d695ef.png";